import { render } from "./UnChecked.vue?vue&type=template&id=770fb6b0"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/UnChecked.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "770fb6b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('770fb6b0', __exports__)) {
    api.reload('770fb6b0', __exports__)
  }
  
  module.hot.accept("./UnChecked.vue?vue&type=template&id=770fb6b0", () => {
    api.rerender('770fb6b0', render)
  })

}


export default __exports__